<template>
  <div>
    <!-- Loading Table -->
    <j-loading-table v-if="isLoading"/>

    <!-- List Group -->
    <v-client-table
      v-show="!isLoading"
      :data="data_group_apps"
      :columns="columns_group"
      :options="table_options_group"
      class="jTable"
    >
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="isModalAppGroupOpen(true)">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="filterGroup(filter_data_group)">
            <j-select
              v-model="select_type_group"
              :options="options_search_group"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              ref="filterInputGroup"
              v-model="filter_data_group"
              placeholder="Search"
              style="width: 250px; height: 35px"/>
          </b-form>
        </b-form>
      </div>

      <div
        slot="id"
        slot-scope="props"
        @click="detailGroup(props.row.id)">
        {{ props.row.id }}
      </div>

      <div
        slot="name"
        slot-scope="props"
        @click="detailGroup(props.row.id)">
        {{ props.row.name }}
      </div>

      <div
        slot="count_apps"
        slot-scope="props"
        @click="detailGroup(props.row.id)">
        {{ props.row.count_apps || 0 }}
      </div>

      <div
        slot="created_at"
        slot-scope="props"
        @click="detailGroup(props.row.id)">
        {{ convertDateTime(props.row.created_at) }}
      </div>

      <div
        slot="updated_at"
        slot-scope="props"
        @click="detailGroup(props.row.id)">
        {{ convertDateTime(props.row.updated_at) }}
      </div>
    </v-client-table>

    <b-modal
      ref="appGroupModal"
      class="mod-form modal-app-type"
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <j-modal-create-group
        @modal-open="isModalAppGroupOpen"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// Components
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jModalCreateGroup from '@/views/setting/jModalCreateGroup';

export default {
  components: {
    jLoadingTable,
    jModalCreateGroup,
  },

  data() {
    return {
      isLoading: true,
      data_group_apps: [],
      filter_data_group: '',
      select_type_group: 'name',
      options_search_group: [
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns_group: ['id', 'name', 'count_apps', 'created_at', 'updated_at'],
      table_options_group: {
        headings: {
          id: 'ID',
          name: 'GROUP NAME',
          count_apps: 'TOTAL APPS',
          created_at: 'CREATED AT',
          updated_at: 'UPDATED AT',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],
      },
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['group_applications_list']),
  },

  watch: {
    group_applications_list(val) {
      this.data_group_apps = val;
    },

    isLoading(val) {
      if (!val) {
        setTimeout(() => {
          this.$refs.filterInputGroup.focus();
        }, 200);
      }
    },
  },

  created() {
    setTimeout(() => {
      this.data_group_apps = this.group_applications_list;
      this.isLoading = false;
    }, 400);
  },

  methods: {
    filterGroup(val) {
      this.data_group_apps = this.group_applications_list.filter(app =>
        app.name.toUpperCase().includes(val.toUpperCase()));
    },

    isModalAppGroupOpen(val) {
      if (val) this.$refs.appGroupModal.show();
      else this.$refs.appGroupModal.hide();
    },

    detailGroup(id) {
      this.$router.push(`/application-manager/group/${id}`);
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/tabs/jApplicationGroupTab.vue